export default "__VITE_ASSET__BzRxCcrB__"